import React from 'react';
import Question from '../organisms/Question';
import Terms from '../organisms/Terms';
import Ads from '../atoms/Ads';
import { Link } from 'react-router-dom';

const QuestionView: React.FC = () => {
  return (
    <div id='page' className='lower-page'>
      <header className='l-header p-header'>
        <h1 className='p-header__logo'>
          <Link to='/'>
            <img src='/img/common/logo.png' alt='SKALE' />
          </Link>
        </h1>
      </header>

      <div id='contents'>
        <div className='c-container -narrow'>
          <Question />

          <div className='p-privacy'>
            <a
              target='_blank'
              href='https://letter-lp.skale.co.jp/terms'
              rel='noreferrer'
              className='c-link'
            >
              利用規約
            </a>
          </div>
        </div>
      </div>

      <footer className='l-footer p-footer'>
        <Ads />
      </footer>
    </div>
  );
};

export default QuestionView;
